import { faBars } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@nextui-org/react'
import React from 'react'

export const SideBarToggle = ({setSidebar,}) => {
  return (
    <Button isIconOnly={true} onClick={()=>{setSidebar(true)}}  style={{backgroundColor:"#F7941D",color:"white"}} size='lg' >
        <FontAwesomeIcon icon={faBars} />
    </Button>
  )
}
